import Organization from ".";

export const organizationRoutes = (data) => [
  {
    path: "/admin/organization",
    title: "Page",
    layout: "admin",
    routeType: "admin",
    component: Organization,
  },
];
